import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.66693 10.6669C1.93359 10.6669 1.33359 10.0669 1.33359 9.33359V2.66693C1.33359 1.93359 1.93359 1.33359 2.66693 1.33359H9.33359C10.0669 1.33359 10.6669 1.93359 10.6669 2.66693M6.66693 5.33359H13.3336C14.07 5.33359 14.6669 5.93055 14.6669 6.66693V13.3336C14.6669 14.07 14.07 14.6669 13.3336 14.6669H6.66693C5.93055 14.6669 5.33359 14.07 5.33359 13.3336V6.66693C5.33359 5.93055 5.93055 5.33359 6.66693 5.33359Z",
      stroke: "currentColor",
      "stroke-width": "1.3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }